export default "__VITE_ASSET__BICTykoA__"